let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gYGtb")).then(() => parcelRequire('44UJy'));